module.exports = __webpack_public_path__ + "static/media/Testimonio3.5038577c.png";